import axios from "axios"

//const
const STORE_USERINFO_FROM_INFO = "editUserCertify/STORE_USERINFO_FROM_INFO"
const STORE_USER_FROM_INFO = "editUserCertify/STORE_USER_FROM_INFO"
const STORE_USER_UPDATE = "editUserCertify/STORE_USER_UPDATE"
const STORE_USERINFO_UPDATE = "editUserCertify/STORE_USERINFO_UPDATE"
const REPRE_LICENSE_LOCATION_GET = "editUserCertify/REPRE_LICENSE_LOCATION_GET"
const REPRE_LICENSE_TYPE_GET = "editUserCertify/REPRE_LICENSE_TYPE_GET"

//reducer
export const editUserInfoBase = (state = {
  licenseHomeLocations: [],
  licenseTypes: [],
  user: {
    realName: "",
  },
  userinfo: {
    licenseHomeLocation: "",
    licenseType: "",
    licenseBackImage: "",
    licenseFrontImage: "",
    licenseIdNumber: "",
    licenseValidTerm: "",
    openingBank: "",
    bankAccount: "",
  },

}, action) => {
  switch (action.type) {
    case STORE_USERINFO_FROM_INFO: {
      console.log("store: ", action.data);
      let newUserInfo = {
        licenseHomeLocation: action.data.licenseHomeLocation,
        licenseType: action.data.licenseType,
        licenseBackImage: action.data.licenseBackImage,
        licenseFrontImage: action.data.licenseFrontImage,
        licenseIdNumber: action.data.licenseIdNumber,
        licenseValidTerm: action.data.licenseValidTerm,
        openingBank: action.data.openingBank,
        bankAccount: action.data.bankAccount,
      };
      return {
        ...state,
        userinfo: newUserInfo
      }
    }
      ;
    case STORE_USERINFO_UPDATE:
      return {
        ...state,
        userinfo: {
          ...state.userinfo,
          [action.data.name]: action.data.value
        }
      };

    case STORE_USER_FROM_INFO: {

      let newUser = {
        realName: action.data.realName,
      };
      return {
        ...state,
        user: newUser
      }
    }
      ;
    case STORE_USER_UPDATE:
      return {
        ...state,
        user: {
          ...state.user,
          [action.data.name]: action.data.value
        }
      };
    case REPRE_LICENSE_TYPE_GET:
      console.log("Type: ", action.data._embedded.repreLicenseTypes)
      return {
        ...state,
        licenseTypes: action.data._embedded.repreLicenseTypes

      };
    case REPRE_LICENSE_LOCATION_GET:
      console.log("REPRELICENSELOCATION: ", action.data._embedded.repreLicenseLocations)
      return {
        ...state,
        licenseHomeLocations: action.data._embedded.repreLicenseLocations

      };
    default:
      return state
  }
};

//action
export const getUserBase = (userId) => (dispatch) => {

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  return axios({
    method: "GET",
    url: `/api-user/users?userId=` + userId,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("get", response.data);
        dispatch(storeUserBase(response.data))
      }
    })
};

export const getUserInfoBase = (userId) => (dispatch) => {

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  return axios({
    method: "GET",
    url: `/api-user/userInfoes?userId=` + userId,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log(response.data);
        dispatch(storeUserInfoBase(response.data))
      }
    })
};

export const storeUserBase = (data) => {
  return {
    type: STORE_USER_FROM_INFO,
    data: data
  }
};

export const storeUserInfoBase = (datainfo) => {
  return {
    type: STORE_USERINFO_FROM_INFO,
    data: datainfo
  }
};

export const update = (data) => {
  return {
    type: STORE_USER_UPDATE,
    data: data
  }
};

export const updateData = (data) => {
  return {
    type: STORE_USERINFO_UPDATE,
    data: data
  }
};


export const getRepreLicenseType = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseTypes`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("repreLicenseTypes", response.data);
        dispatch(getRepreLicenseTypeDone(response.data))
      }
    })
}

export const getRepreLicenseLocation = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseLocations`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("repreLicenseLocation", response.data);
        dispatch(getRepreLicenseLocationDone(response.data))
      }
    })
}

export const getRepreLicenseLocationDone = (data) => {
  return {
    type: REPRE_LICENSE_LOCATION_GET,
    data: data
  }
};

export const getRepreLicenseTypeDone = (data) => {
  return {
    type: REPRE_LICENSE_TYPE_GET,
    data: data
  }
};
